// removed by extract-text-webpack-plugin
module.exports = {"fileWrapper":"NTiWv9Y4oDlWc0HEfkDPI","fileWrapperBigText":"_1oYbJH2yBKc6GDB9XnvmTL","fileWrapperSmallText":"_2wpAEcESbBeKmind5tqYvU","icon":"_3QVhmkRiQhorXx0sYuGAMI"};